<div class="font-bold mb-3" i18n>You have chosen to configure the "Admin Agent" for HTTP-OTA. Please fill in the blanks.</div>
<div class="ml-6">
  <div class="mt-4">
    <span class="mr-1 required-field">*</span>
    <span i18n>Indicates a required field.</span>
  </div>
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="mt-3" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
  <table class="pt-3 mb-6">
    <tr>
      <td colspan="2">
        <div class="mb-3 font-bold" i18n>Connection Parameters</div>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Command Details</span>
      </td>
      <td style="width: 725px" (mouseover)="showTip(C.TIP_EWIZ_COMMAND_DETAILS)" (mouseout)="clearDynamicToast()">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="6"
          [(ngModel)]="profileValues.adminAgent.commandDetails[0]"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Device Identities</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_DEVICE_IDENTITIES)" (mouseout)="clearDynamicToast()">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="4"
          [(ngModel)]="profileValues.adminAgent.deviceIdentities"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>Alpha ID Open Channel</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_ALPHA_ID_OPEN_CHANNEL)" (mouseout)="clearDynamicToast()">
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.alphaIdOpenChannel"
          maxlength="255"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Bearer Description</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_BEARER_DESCRIPTION)" (mouseout)="clearDynamicToast()">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="2"
          [(ngModel)]="profileValues.adminAgent.bearerDescription"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Buffer Size</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_BUFFER_SIZE)" (mouseout)="clearDynamicToast()">
        <p-inputNumber
          class="maximize-inputs"
          inputStyleClass="maximize-inputs console-text"
          [(ngModel)]="profileValues.adminAgent.bufferSize"
          [maxlength]="5"
          [useGrouping]="false"
          (onBlur)="handleFormEvents()"
        ></p-inputNumber>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Network Access Name</span>
      </td>
      <td>
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.networkAccessName"
          maxlength="255"
          (input)="handleFormEvents()"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>User Login</span>
      </td>
      <td>
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.userLogin"
          maxlength="255"
          (input)="handleFormEvents()"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>User Password</span>
      </td>
      <td>
        <p-password
          styleClass="maximize-inputs"
          inputStyleClass="maximize-inputs"
          [(ngModel)]="profileValues.adminAgent.userPassword"
          [toggleMask]="true"
          (onBlur)="handleFormEvents()"
        ></p-password>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Transport Protocol Type</span>
      </td>
      <td>
        <p-select
          styleClass="maximize-inputs"
          [options]="transportProtocolTypes"
          [(ngModel)]="profileValues.adminAgent.transportProtocolType"
          dataKey="value"
          optionLabel="label"
          i18n-placeholder
          placeholder="Please Select:"
          appendTo="body"
          (onChange)="handleFormEvents()"
        ></p-select>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Port Number</span>
      </td>
      <td>
        <p-inputNumber
          class="maximize-inputs"
          inputStyleClass="maximize-inputs console-text"
          [(ngModel)]="profileValues.adminAgent.portNumber"
          [maxlength]="5"
          [useGrouping]="false"
          (onBlur)="handleFormEvents()"
        ></p-inputNumber>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Data Destination Type</span>
      </td>
      <td>
        <table>
          <tr>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="profileValues.adminAgent.dataDestinationType"
                inputId="profileValues.adminAgent.dataDestinationType#1"
                value="1"
                [(ngModel)]="profileValues.adminAgent.dataDestinationType"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="profileValues.adminAgent.dataDestinationType#1" i18n>IPv4</label>
            </td>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="profileValues.adminAgent.dataDestinationType"
                inputId="profileValues.adminAgent.dataDestinationType#2"
                value="2"
                [(ngModel)]="profileValues.adminAgent.dataDestinationType"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="profileValues.adminAgent.dataDestinationType#2" i18n>IPv6</label>
            </td>
            <td (mouseover)="showTip(C.TIP_EWIZ_NO_DATA_DESTINATION_TYPE)" (mouseout)="clearDynamicToast()">
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="profileValues.adminAgent.dataDestinationType"
                inputId="profileValues.adminAgent.dataDestinationType#3"
                value="3"
                [(ngModel)]="profileValues.adminAgent.dataDestinationType"
              ></p-radioButton>
            </td>
            <td (mouseover)="showTip(C.TIP_EWIZ_NO_DATA_DESTINATION_TYPE)" (mouseout)="clearDynamicToast()">
              <label class="ml-2 mr-6 label-clickable" for="profileValues.adminAgent.dataDestinationType#3" i18n>None</label>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr *ngIf="+profileValues.adminAgent.dataDestinationType !== 3">
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Data Destination Address</span>
      </td>
      <td>
        <table *ngIf="+profileValues.adminAgent.dataDestinationType === 1">
          <tr>
            <td>
              <p-inputNumber
                class="maximize-inputs"
                inputStyleClass="maximize-inputs console-text"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv4.address1"
                [min]="0"
                [max]="255"
                [maxlength]="3"
                [useGrouping]="false"
                (onBlur)="handleFormEvents()"
              ></p-inputNumber>
            </td>
            <td><span>.</span></td>
            <td>
              <p-inputNumber
                class="maximize-inputs"
                inputStyleClass="maximize-inputs console-text"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv4.address2"
                [min]="0"
                [max]="255"
                [maxlength]="3"
                [useGrouping]="false"
                (onBlur)="handleFormEvents()"
              ></p-inputNumber>
            </td>
            <td><span>.</span></td>
            <td>
              <p-inputNumber
                class="maximize-inputs"
                inputStyleClass="maximize-inputs console-text"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv4.address3"
                [min]="0"
                [max]="255"
                [maxlength]="3"
                [useGrouping]="false"
                (onBlur)="handleFormEvents()"
              ></p-inputNumber>
            </td>
            <td><span>.</span></td>
            <td>
              <p-inputNumber
                class="maximize-inputs"
                inputStyleClass="maximize-inputs console-text"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv4.address4"
                [min]="0"
                [max]="255"
                [maxlength]="3"
                [useGrouping]="false"
                (onBlur)="handleFormEvents()"
              ></p-inputNumber>
            </td>
          </tr>
        </table>
        <table *ngIf="+profileValues.adminAgent.dataDestinationType === 2">
          <tr>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address1"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address2"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address3"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address4"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address5"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address6"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address7"
                (input)="handleFormEvents()"
              />
            </td>
            <td><span>:</span></td>
            <td style="min-width: 3.5rem">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="4"
                [(ngModel)]="profileValues.adminAgent.dataDestinationAddress.ipv6.address8"
                (input)="handleFormEvents()"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="mb-3 mt-3 font-bold" i18n>Security Parameters</div>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>PSK identity</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_PSK_IDENTITY)" (mouseout)="clearDynamicToast()">
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.pskIdentity"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Key Version</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_KEY_VERSION)" (mouseout)="clearDynamicToast()">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="2"
          [(ngModel)]="profileValues.adminAgent.keyVersion"
          (input)="handleFormEvents()"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Key Identifier</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_KEY_IDENTIFIER)" (mouseout)="clearDynamicToast()">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text"
          [maxlength]="2"
          [(ngModel)]="profileValues.adminAgent.keyIdentifier"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="mb-3 mt-3 font-bold" i18n>Retry Policy Parameters</div>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>Retry Counter</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_RETRY_COUNTER)" (mouseout)="clearDynamicToast()">
        <p-inputNumber
          class="maximize-inputs"
          inputStyleClass="maximize-inputs console-text"
          [(ngModel)]="profileValues.adminAgent.retryCounter"
          [useGrouping]="false"
          (onBlur)="handleFormEvents()"
          [min]="0"
          [max]="9999"
        ></p-inputNumber>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>Retry Waiting Delay</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_RETRY_WAITING_DELAY)" (mouseout)="clearDynamicToast()">
        <table cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <rs-fixed-digits-number-input
                [(value)]="profileValues.adminAgent.retryHours"
                [inputStyleClass]="'maximize-inputs console-text'"
                [styleClass]="'maximize-inputs'"
                [useGrouping]="false"
                [min]="0"
                [max]="99"
                [maxLength]="2"
                [padMissingDigitsToLength]="2"
                [minFractionDigits]="0"
                [maxFractionDigits]="0"
                [ariaLabel]="retryHoursAriaLabel"
                (valueChange)="handleFormEvents()"
              ></rs-fixed-digits-number-input>
            </td>
            <td>
              <div class="ml-2 mr-6" i18n>Hours</div>
            </td>
            <td>
              <rs-fixed-digits-number-input
                [(value)]="profileValues.adminAgent.retryMinutes"
                [inputStyleClass]="'maximize-inputs console-text'"
                [styleClass]="'maximize-inputs'"
                [useGrouping]="false"
                [min]="0"
                [max]="59"
                [maxLength]="2"
                [padMissingDigitsToLength]="2"
                [minFractionDigits]="0"
                [maxFractionDigits]="0"
                [ariaLabel]="retryMinutesAriaLabel"
                (valueChange)="handleFormEvents()"
              ></rs-fixed-digits-number-input>
            </td>
            <td>
              <div class="ml-2 mr-6" i18n>Minutes</div>
            </td>
            <td>
              <rs-fixed-digits-number-input
                [(value)]="profileValues.adminAgent.retrySeconds"
                [inputStyleClass]="'maximize-inputs console-text'"
                [styleClass]="'maximize-inputs'"
                [useGrouping]="false"
                [min]="0"
                [max]="59"
                [maxLength]="2"
                [padMissingDigitsToLength]="2"
                [minFractionDigits]="0"
                [maxFractionDigits]="0"
                [ariaLabel]="retrySecondsAriaLabel"
                (valueChange)="handleFormEvents()"
              ></rs-fixed-digits-number-input>
            </td>
            <td>
              <div class="ml-2" i18n>Seconds</div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="mb-3 mt-3 font-bold" i18n>HTTP POST Parameters</div>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Administration Host Parameters</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_ADMINISTRATION_HOST_PARAMETERS)" (mouseout)="clearDynamicToast()">
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.administrationHostParameters"
          (input)="handleFormEvents()"
          maxlength="255"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-3" i18n>Agent ID Parameter</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_AGENT_ID_PARAMETER)" (mouseout)="clearDynamicToast()">
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.agentIdParameter"
          (input)="handleFormEvents()"
          [disabled]="true"
        />
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-1 required-field">*</span>
        <span class="mr-3" i18n>Administration URI Parameter</span>
      </td>
      <td (mouseover)="showTip(C.TIP_EWIZ_ADMINISTRATION_URI_PARAMETER)" (mouseout)="clearDynamicToast()">
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.adminAgent.administrationURIParameter"
          (input)="handleFormEvents()"
          maxlength="255"
        />
      </td>
    </tr>
  </table>
</div>
